(function ($) {

	// calculate hero margins
	const setHeroTitleMargins = function() {

		const $el = $('.single-microgrid .hero'),
		elHeight = $el.outerHeight();

		$el.css('margin-bottom', `-${elHeight}px`);

	}

	$(window).on( 'resize', setHeroTitleMargins );
	setTimeout( setHeroTitleMargins, 1000 );

	// create a FullPage
	new fullpage('#fullpage', {
		licenseKey: '0M21I-1Z7S9-XJK98-5JD07-KBCQP',
		anchors: ['splash-page', 'landing-page', 'content-page'],
		recordHistory: false,
		lockAnchors: false,
		keyboardScrolling: false,
    dragAndMove: false,
		afterRender: function () {

			if( $('body').hasClass('single-microgrid') ) {
				fullpage_api.silentMoveTo(3);
			}

			
			if( $('#microgrid-landing-page').length ) {
				/*
				gsap.to("#voltage", {
					duration: 45,
					repeat: -1,
					ease: gsap.parseEase("linear"),
					motionPath: {
						path: "#voltage-path",
						align: "#voltage-path",
						autoRotate: true,
						alignOrigin: [0.5, 0.5]
					}
				});

				gsap.to("#voltage2", {
					duration: 45,
					repeat: -1,
					ease: gsap.parseEase("linear"),
					motionPath: {
						path: "#voltage-path-2",
						align: "#voltage-path-2",
						autoRotate: true,
						alignOrigin: [0.5, 0.5]
					}
				});
				*/

				gsap.to( document.getElementsByClassName('wind-blades'), 3, {rotation:"360", ease:Linear.easeNone, repeat:-1, transformOrigin:"center center", });
				

			}

			$('body').css('opacity', '1');

		}
	});

	fullpage_api.setMouseWheelScrolling(false);
	fullpage_api.setAllowScrolling(false);
	fullpage_api.setFitToSection(false);

	// landing - SVG icons on hover
	$('.section-landing').on( 'mouseenter', '.item-group', function() {

		const $group = $(this),
		$icon = $group.find('.item-icon'),
		$title = $group.find('.item-title');

		$icon.attr('stroke-width', '8');
		$title.css('opacity', '1').css('visibility', 'visible');

	}).on( 'mouseleave', '.item-group', function() {

		const $group = $(this),
		$icon = $group.find('.item-icon'),
		$title = $group.find('.item-title');

		$icon.attr('stroke-width', '3');
		$title.css('opacity', '0').css('visibility', 'hidden');

	});

	// landing - SVG icons on click
	$('.section-landing .item-group').on( 'click', function( e ) {
		e.preventDefault();

		const $item = $(this),
		id = $item.attr('id'),
		cardId = `#card-${id}`;

		$('.landing-card').removeClass('is-visible');
		$( cardId ).addClass('is-visible');

	});

	const closeHotspots = function() {

		$('.hotspot-icon-group').each(function() {

			const $stroke = $(this).find('.hotspot-icon');
			$stroke.attr('stroke-width', '3');
			$stroke.attr('fill', '#009E77');

			$(this).removeClass('is-active-now');

			const linkTo = $(this).attr('mydata:href');
			$(`#title-${linkTo}`).stop().fadeOut();

		});

	}

	$('.section-landing .card-close').on( 'click', function( e ) {
		e.preventDefault();

		$(this).parents('.landing-card').removeClass('is-visible');
		closeHotspots();

	});

	$('.mobile-navigation .nav-item').on( 'click', function( e ) {
		e.preventDefault();

		const $link = $(this),
		cardId = $link.attr('href');

		$('.landing-card').removeClass('is-visible');
		$( cardId ).addClass('is-visible');

	});

	// close cards by clicking outside
	$(document).on( 'click', function( e ) {

		if( $( e.target).closest( '.landing-card, .section-landing .item-group, .mobile-navigation .nav-item, .hotspot-icon, .hotspot-plus, .hotspot-icon-group').length === 0) {
			$('.landing-card').removeClass('is-visible');
			closeHotspots();
		}

	});

	if( $('body').hasClass('single-microgrid') ) {
		$('.posts-menu-items .items').animate({
			scrollLeft: $('.posts-menu-items .is-active').offset().left - ($(window).width() / 2 ) + ( $('.posts-menu-items .is-active').outerWidth() / 2 )
		}, 300, 'swing');
	}

	$('#back-to-landing').on( 'click', function( e ) {
		e.preventDefault();
		fullpage_api.moveTo(2);
		fullpage_api.fitToSection();
		window.history.replaceState('', '', '/explore-microgrid/#landing-page');
		setTimeout( function() {
			$('#microgrid-single-page').remove();
		}, 500 )
	});

	// skip hero
	$('#skip-hero').on( 'click', function( e ) {
		e.preventDefault();

		$('#microgrid-single-page .fp-overflow').animate({
			scrollTop: $('#section-content-items').offset().top - 50
		}, 1000);
		
	});

	// accordion
	$('.pb-component-accordion .item-title').on( 'click', function( e ) {
		e.preventDefault();

		const $title = $(this),
		$item = $title.parents('.item'),
		$content = $item.find('.item-content'),
		$opened = $item.parents('.pb-component-accordion').find('.is-open');

		$opened.find('.item-content').not( $content ).slideUp( 'fast', function() {
			$opened.removeClass('is-open');
		});

		$content.slideToggle( 'fast', function() {
			$item.toggleClass('is-open');
		});

	});

	// hotspot icons
	$('.hotspot-icon-group').on('mouseenter', function() {

		const $stroke = $(this).find('.hotspot-icon');
		$stroke.attr('stroke-width', '8');
		$stroke.attr('fill', '#027157');

		const linkTo = $(this).attr('mydata:href');
		$(`#title-${linkTo}`).stop().fadeIn();

	}).on( 'mouseleave', function() {

		const $group = $(this);

		if( ! $group.hasClass('is-active-now') ) {
			const $stroke = $(this).find('.hotspot-icon');
			$stroke.attr('stroke-width', '3');
			$stroke.attr('fill', '#009E77');

			const linkTo = $(this).attr('mydata:href');
			$(`#title-${linkTo}`).stop().fadeOut();
		}

	});

	$('.hotspot-icon, .hotspot-plus').on( 'click', function( e ) {
		e.preventDefault();

		const $group = $(this).parents('.hotspot-icon-group'),
		linkTo = $group.attr('mydata:href');

		$('.hotspot-icon-group').not( $group ).each(function() {

			const $stroke = $(this).find('.hotspot-icon');
			$stroke.attr('stroke-width', '3');
			$stroke.attr('fill', '#009E77');

			$(this).removeClass('is-active-now');

			const linkTo = $(this).attr('mydata:href');
			$(`#title-${linkTo}`).stop().fadeOut();

		});

		$group.addClass('is-active-now');

		$('.landing-card').removeClass('is-visible');

		$(`#card-${linkTo}`).css('top', ($('.landing-map').outerHeight() / 2) + 'px' );

		$(`#card-${linkTo}`).addClass('is-visible');

	});

})(window.jQuery);